import { render, staticRenderFns } from "./ListOfOrders.vue?vue&type=template&id=59d0c0e2&"
import script from "./ListOfOrders.vue?vue&type=script&lang=js&"
export * from "./ListOfOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports